import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const FeedbackGrid = ({icon, label, subLabel}) => {
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1}>
      <Grid item>
        {icon}
      </Grid>
      <Grid item>
        <Typography variant="h6" fontSize={23}>
          {label}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body2" fontSize={15}>
          {subLabel}
        </Typography>
      </Grid>
    </Grid>
  );
};

FeedbackGrid.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  subLabel: PropTypes.string
};

export default FeedbackGrid;
